import React from 'react';
import Image from 'next/image';
import StarIconNew from './StarIconNew.svg';
import EmptyStarNew from './EmptyStarIconNew.svg';
import HalfStarNew from './HalfStarIconNew.svg';

type StarRatingProps = {
  algoliaRating: number;
  algoliaReviews: number;
  reviewsThreshold?: number;
  hideReviewsNumber?: boolean;
  onClick?: () => void;
};

function calculateStarPercentage(rating: number) {
  // Ensure rating is between 0 and 5
  const clampedRating = Math.min(5, Math.max(0, rating));

  // Calculate percentage for each star
  const fullStars = Math.floor(clampedRating);
  const remainderPercentage = (clampedRating - fullStars) * 100;

  // Create array of percentages for each star
  const starPercentages = Array(5)
    .fill(0)
    .map((_, index) => {
      if (index < fullStars) {
        return 100;
      }
      if (index === fullStars) {
        return Number(remainderPercentage.toFixed(1));
      }
      return 0;
    });
  return starPercentages;
}

export default function StarRating({
  algoliaRating = 0,
  algoliaReviews = 0,
  reviewsThreshold = 0,
  hideReviewsNumber = false,
  onClick = () => null,
}: StarRatingProps) {
  // eslint-disable-next-line no-nested-ternary
  return algoliaReviews > 0 && algoliaReviews >= reviewsThreshold ? (
    <div
      className="flex"
      style={{ width: 'fit-content' }}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          if (onClick) {
            onClick();
          }
        }
      }}
    >
      <div className="flex items-center">
        <div className="flex gap-3.5px">
          {calculateStarPercentage(Number(algoliaRating.toFixed(1))).map((value, index) => {
            let star;
            if (value === 100) {
              star = StarIconNew;
            } else if (value >= 30) {
              star = HalfStarNew;
            } else {
              star = EmptyStarNew;
            }
            return <Image key={`item-${index.toString()}`} src={star} alt="star" />;
          })}
        </div>
        <span className="ml-2 font-rp-basetica tracking-normal text-sm text-rp-neutral">
          {algoliaRating.toFixed(1)}
        </span>
      </div>

      {algoliaReviews && !hideReviewsNumber ? (
        <span className="font-rp-basetica tracking-normal ml-1 text-sm text-rp-text-secondary">
          ({algoliaReviews})
        </span>
      ) : null}
    </div>
  ) : (
    <div className="h-18px" />
  );
}
